import styles from './../styles.module.css'

export default function getClass(className) {
    return styles && styles[className] ? styles[className] : className
}
